import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, DelegateInvitationEventActionId, userTypeActionId, delegateInvitationTypeActionId, exhibitionActionId, toastError, toastSuccess } from "../../../../utils/constants";
import { emailValidator } from "../../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { insertUpdate_InvitationAllocation_action, getInvitationAllocation_action } from "../../../../actions/admin_module_action/delegate_master_action/delegate_InvitationAllocation_action";
import Select from 'react-select';
import Footer from "../../../../common_components/Footer";
import { Item } from "@hilla/react-components/Item.js";
import { Tune } from "@mui/icons-material";

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        "&:hover": {
            backgroundColor: "#00BCD4",
            color: "#fff", // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};
class Delegate_InvitationAllocationtList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            countryList: [],
            InvitationAllocationtList: [],
            deleteID: '',
            InvitationAllocationtName: '',
            Status: '',
            isOpen2: false,
            is_add: false,
            InvitationAllocationtID: '',
            diplayStatus: 1,
            exhibitionID: '',
            exhibitionList: [],
            InvitationEventId: '',
            InvitationEventList: [],
            ExhibitorList: [],
            VisitorList: [],
            DelegateList: [],
            VIPList: [],
            GuestList: [],
            SpeakerList: [],
            GovtList: [],
            Designation: '',
            CompanyName: '',
            CountryName: '',
            EmailID: '',
            Name: '',
            userTypeId: '',
            userTypeList: [],
            allOption: { value: "all", label: "Select All" },
            isExhibitorList: true,
            isVisitorList: true,
            isDelegateList: true,
            isVIPList: true,
            isGuestList: true,
            isSpeakerList: true,
            isGovtList: true,
            scheduleInvitation: 1,
            ScheduleDate: new Date(),
            ScheduleTime: moment(new Date()).seconds(0).format('HH:mm:ss')
        }
    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '').then(() => {
        })
        this.getFillList(userTypeActionId, '', '', '', '', '').then(() => {
        })
        console.log('ScheduleDate', new Date())
        console.log('ScheduleTime', moment(new Date()).seconds(0).format('HH:mm:ss'))
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === exhibitionActionId) {
                            this.setState({
                                exhibitionList: data.data.length > 0 ? data.data : [],
                                isLoading: false
                            })
                        }
                        if (actionID === DelegateInvitationEventActionId) {
                            if (data.data != '') {
                                const Array = []
                                data.data.map(item => {
                                    Array.push({ label: item.Name, value: item.InvitationEventID })
                                })
                                this.setState({
                                    InvitationEventList: Array
                                })
                            } else {
                                this.setState({
                                    InvitationEventList: data.data
                                })
                            }
                        }
                        if (actionID === userTypeActionId) {
                            const Array = []
                            data.data.map(item => {
                                Array.push({ label: item.Name, value: item.AccountTypeID })
                            })
                            this.setState({
                                userTypeList: Array
                            })
                        }
                        resolve(true)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    getInvitationAllocationtList() {
        this.setState({ isLoading: true })
        const { exhibitionID, InvitationEventId, Designation, CompanyName, CountryName, EmailID, Name, userTypeId, userTypeList } = this.state
        const array = []
        if (InvitationEventId != '') {
            InvitationEventId.map(item => {
                array.push({ InvitationEventID: item.value })
            })
        }
        if (exhibitionID != '' && array != '') {
            this.props.getInvitationAllocation_action(exhibitionID, array, Designation, CompanyName, CountryName, EmailID, Name)
                .then((data) => {
                    if (data.error != 1) {
                        function cheked(array) {
                            if (array != '') {
                                array.map(item => {
                                    if (item.isChecked) {
                                        item.ActionID = 1
                                    } else {
                                        item.ActionID = 0
                                    }
                                })
                            }
                            return array
                        }
                        console.log("userTypeId-------->1", userTypeId)
                        if (userTypeId && userTypeId.length > 0) {
                            this.setState({
                                isExhibitorList: userTypeId.some(item => 'Exhibitor' == item.label),
                                isVisitorList: userTypeId.some(item => 'Visitor' == item.label),
                                isDelegateList: userTypeId.some(item => 'Delegate' == item.label),
                                isVIPList: userTypeId.some(item => 'VIPs' == item.label),
                                isGuestList: userTypeId.some(item => 'Guests' == item.label),
                                isSpeakerList: userTypeId.some(item => 'Speakers' == item.label),
                                isGovtList: userTypeId.some(item => 'Goverment Officer' == item.label),
                            });
                        } else {
                            this.setState({
                                isExhibitorList: true,
                                isVisitorList: true,
                                isDelegateList: true,
                                isVIPList: true,
                                isGuestList: true,
                                isSpeakerList: true,
                                isGovtList: true,
                            });
                        }

                        this.setState({
                            ExhibitorList: cheked(data.Exhibitor),
                            VisitorList: cheked(data.Visitor),
                            DelegateList: cheked(data.Delegate),
                            VIPList: cheked(data.VIP),
                            GuestList: cheked(data.Guest),
                            SpeakerList: cheked(data.Speaker),
                            GovtList: cheked(data.Govt),
                        })
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError("Please select Exhibition and Event!")
            this.setState({ isLoading: false })
        }
    }

    clearSearch() {
        const { Stateno, PANNo } = this.state
        this.setState({
            Designation: '',
            CompanyName: '',
            CountryName: '',
            EmailID: '',
            Name: '',
            isExhibitorList: true,
            isVisitorList: true,
            isDelegateList: true,
            isVIPList: true,
            isGuestList: true,
            isSpeakerList: true,
            isGovtList: true,
            userTypeId: ''
        })
        setTimeout(() => {
            this.state.InvitationEventId != '' && this.getInvitationAllocationtList()
        }, 100);
    }

    handleAdd() {
        this.props.navigate('/delegateInvitationAllocationtAU', { state: { is_add: true, } })
    }

    handleUpdate(id, value) {
        if (value == 'isUpdate') {
            this.props.navigate('/delegateInvitationAllocationtAU', { state: { is_update: true, is_view: false, InvitationAllocationtID: id } })
        } else {
            this.props.navigate('/delegateInvitationAllocationtAU', { state: { is_update: true, is_view: true, InvitationAllocationtID: id } })
        }
    }

    insertUpdateInvitationAllocationt(id) {
        const { ExhibitorList, VisitorList, DelegateList, VIPList, GuestList, SpeakerList, GovtList, InvitationEventId, exhibitionID, scheduleInvitation, ScheduleDate, ScheduleTime } = this.state
        const selectedData = []
        function mapSelectedData(array, InvitationEventID) {
            if (array != '') {
                array.map((item) => {
                    if (item.isChecked || item.ActionID == 3) {
                        selectedData.push(
                            {
                                InvitationEventID: InvitationEventID,
                                RegistrationID: item.RegistrationID,
                                AccountTypeID: item.AccountTypeID,
                                ActionID: item.ActionID,
                                EmailID: item.EmailID,
                                CompanyName: item.CompanyName,
                                Designation: item.Designation,
                                CountryName: item.CountryName,
                                Name: item.Name,
                                IsMailSend: item.IsMailSend,
                                AccountTypeID: item.AccountTypeID,
                                RegistrationID: item.RegistrationID,
                            }
                        )
                    }
                })
            }
        }
        for (let i = 0; i < InvitationEventId.length; i++) {
            mapSelectedData(ExhibitorList, InvitationEventId[i]['value'])
            mapSelectedData(VisitorList, InvitationEventId[i]['value'])
            mapSelectedData(DelegateList, InvitationEventId[i]['value'])
            mapSelectedData(VIPList, InvitationEventId[i]['value'])
            mapSelectedData(GuestList, InvitationEventId[i]['value'])
            mapSelectedData(SpeakerList, InvitationEventId[i]['value'])
            mapSelectedData(GovtList, InvitationEventId[i]['value'])
        }

        var scheduleInvitationFlag
        if (ScheduleDate != '' && ScheduleDate != null && ScheduleTime != '' && ScheduleTime != null) {
            scheduleInvitationFlag = true
        } else {
            scheduleInvitationFlag = false
        }

        if (scheduleInvitationFlag) {
            this.props.insertUpdate_InvitationAllocation_action(exhibitionID, selectedData, scheduleInvitation, ScheduleDate, ScheduleTime)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        toastSuccess("Invitation sent successfully")
                        setTimeout(() => {
                            this.getInvitationAllocationtList()
                        }, 200);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                    this.setState({ isOpen: false })
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError("Please Select Schedule")
        }
    }

    onDelete(id) {
        const { } = this.state
        this.setState({ deleteID: id })
        this.setState({ isOpen: true, })
    }

    oCheckbox(event, i, value) {
        const { ExhibitorList, VisitorList, DelegateList, VIPList, GuestList, SpeakerList, GovtList, InvitationEventId } = this.state
        function valueCheked(array) {
            if (array != '') {
                array.map((item, index) => {
                    if (i === index) {
                        item.isChecked = event
                        if (item.ActionID == 1 || item.ActionID == 3) {
                            if (item.isChecked) {
                                item.ActionID = 1
                            } else {
                                item.ActionID = 3
                            }
                        } else if (item.ActionID == 0 || item.ActionID == 2) {
                            if (item.isChecked) {
                                item.ActionID = 2
                            } else {
                                item.ActionID = 0
                            }
                        }
                    }
                })
                return array
            }
        }
        if (value == 'Exhibitor') {
            this.setState({ ExhibitorList: valueCheked(ExhibitorList) })
        } else if (value == 'Visitor') {
            this.setState({ VisitorList: valueCheked(VisitorList) })
        } else if (value == 'Delegate') {
            this.setState({ DelegateList: valueCheked(DelegateList) })
        } else if (value == 'VIP') {
            this.setState({ VIPList: valueCheked(VIPList) })
        } else if (value == 'Guest') {
            this.setState({ GuestList: valueCheked(GuestList) })
        } else if (value == 'speaker') {
            this.setState({ SpeakerList: valueCheked(SpeakerList) })
        } else if (value == 'Govt') {
            this.setState({ GovtList: valueCheked(GovtList) })
        }
    }

    handleChange = (selected, selectedData) => {
        const { userTypeList } = this.state
        const allOption = { value: "all", label: "Select All" }
        if (selectedData.option != undefined && selectedData.option.value == "all") {
            this.setState({ userTypeId: userTypeList.concat(allOption) })
        } else {
            if (selectedData.removedValue != undefined && selectedData.removedValue.value == "all") {
                this.setState({ userTypeId: [] })
            } else {
                this.setState({ userTypeId: selected })
            }
        }
    };

    onScheduleChange(event, value) {
        if (value == 'ScheduleDate') {
            this.setState({ ScheduleDate: event })
        } else if (value == 'ScheduleTime') {
            this.setState({ ScheduleTime: event })
        }
    }

    render() {
        const { isOpen, isLoading, InvitationEventId, InvitationEventList, Designation, CompanyName, CountryName, EmailID, Name, userTypeId, userTypeList, allOption, isExhibitorList, isVisitorList, isDelegateList, isVIPList, isGuestList, isSpeakerList, isGovtList, ScheduleDate, ScheduleTime } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height"style={{marginTop:'5rem'}}>
                        <AdminDrawer />
                        <div className="row" style={{ marginLeft: '0.3rem' }}>
                            <div className="step-name">
                                <p>Delegate Invitation Allocation</p>
                            </div>
                        </div>
                        <div className="m-3">
                            <div className="row ">
                                <div className="col-md-3">
                                    <label >Exhibition Name<span className="text-red">*</span></label>
                                    <select className="form-control"
                                        value={this.state.exhibitionID}
                                        onChange={(e) =>
                                            this.setState({ exhibitionID: e.target.value, InvitationEventId: '' }, () => {
                                                e.target.value != '' ?
                                                    this.getFillList(DelegateInvitationEventActionId, e.target.value, '', '', '', '')
                                                    : this.setState({ InvitationEventId: '', InvitationEventList: [] })
                                            })
                                        }
                                    >
                                        <option value={''}>Select Exhibition</option>
                                        {
                                            this.state.exhibitionList.length > 0 && this.state.exhibitionList.map((data) => (
                                                <option key={data.ExhibitionID} value={data.ExhibitionID}>{data.ExhibitionName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-9">
                                    <label >Invitation Event<span className="text-red">*</span></label>
                                    <Select
                                        isMulti
                                        styles={customStyles}
                                        value={InvitationEventId}
                                        onChange={e => this.setState({ InvitationEventId: e }, () => {
                                            if (e != '') {
                                                this.getInvitationAllocationtList()
                                            } else {
                                                this.clearSearch()
                                                this.setState({
                                                    ExhibitorList: [],
                                                    VisitorList: [],
                                                    DelegateList: [],
                                                    VIPList: [],
                                                    GuestList: [],
                                                    SpeakerList: [],
                                                    GovtList: [],
                                                })
                                            }
                                        })}
                                        options={InvitationEventList} />
                                </div>

                            </div>
                            <hr></hr>

                            <p className="m-0"><strong>Search Fields:</strong></p>
                            <div className="row mt-2">
                                <div className="col-md-3">
                                    <label >Company Name</label>
                                    <input className="form-control"
                                        value={CompanyName}
                                        onChange={(e) => this.setState({ CompanyName: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label >Person Name</label>
                                    <input className="form-control"
                                        value={Name}
                                        onChange={(e) => this.setState({ Name: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label >Designation</label>
                                    <input className="form-control"
                                        value={Designation}
                                        onChange={(e) => this.setState({ Designation: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label >EmailID</label>
                                    <input className="form-control"
                                        value={EmailID}
                                        onChange={(e) => this.setState({ EmailID: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3 mt-2">
                                    <label >Country Name</label>
                                    <input className="form-control"
                                        value={CountryName}
                                        onChange={(e) => this.setState({ CountryName: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-6 mt-2">
                                    <label >User Type</label>
                                    <Select
                                        isMulti
                                        styles={customStyles}
                                        value={userTypeId}
                                        onChange={(e, i) => this.handleChange(e, i)}
                                        options={[allOption, ...userTypeList]} />
                                </div>
                                <div className="col-md-3 mt-2" style={{ textAlign: 'left' }}>
                                    <label>&emsp;</label>
                                    <button Event="button" className="btn btn-aqua ad-fil-btn rounded-2"
                                        onClick={e => this.getInvitationAllocationtList()}
                                    >
                                        Search
                                    </button>
                                    <button Event="button" className="btn px-3 btn-outline-secondary rounded-2 ms-2"
                                        onClick={e => this.clearSearch()}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div class="col-md-3 mt-2">
                                    <label for="validationCustom03">Schedule Invitation<span className="text-red">*</span></label>
                                    <div className="d-flex mt-2">
                                        <label style={{ width: '0px', marginRight: '15px' }}>
                                            <input
                                                className="mr-1"
                                                style={{ verticalAlign: 'middle' }}
                                                type="radio"
                                                value="option1"
                                                checked={this.state.scheduleInvitation === 1}
                                                onChange={(e) => this.setState({ scheduleInvitation: 1 }, () => {
                                                    console.log("new Date()--->", new Date())
                                                    this.setState({
                                                        ScheduleDate: new Date(),
                                                        ScheduleTime: moment(new Date()).seconds(0).format('HH:mm:ss'),
                                                    })
                                                })}
                                            />
                                            Send Now
                                        </label>
                                        <label >
                                            <input
                                                style={{ verticalAlign: 'middle' }}
                                                type="radio"
                                                className="mr-1"
                                                value="option2"
                                                checked={this.state.scheduleInvitation === 2}
                                                onChange={(e) => this.setState({ scheduleInvitation: 2 }, () => {
                                                    this.setState({
                                                        ScheduleDate: '',
                                                        ScheduleTime: '',
                                                    })
                                                })}
                                            />
                                            schedule later
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {this.state.scheduleInvitation == 2 && <div className="row">
                                <div class="col-md-3 mt-2">
                                    <label for="validationCustom03">Schedule Date<span className="text-red">*</span></label>
                                    <DatePicker selected={ScheduleDate}
                                        onChange={(date) => this.onScheduleChange(new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), 'ScheduleDate')}
                                        dateFormat={"dd/MM/yyyy"} className="form-control rounded-1 px-2"
                                        peekNextMonth
                                        minDate={new Date()}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        placeholderText="DD/MM/YYYY"
                                        dayClassName={() => "example-datepicker-day-class"}
                                        popperClassName="example-datepicker-class" />
                                </div>
                                <div class="col-md-3 mt-2">
                                    <label for="validationCustom03">Schedule Time<span className="text-red">*</span></label>
                                    <input
                                        type="time"
                                        className="form-control rounded-1 px-2"
                                        value={ScheduleTime}
                                        onChange={(e) => this.onScheduleChange(e.target.value, 'ScheduleTime')}
                                    />
                                </div>
                            </div>}
                            {isExhibitorList && <div className="col-md-12 p-0 mt-4">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to Exhibitor's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{}}>Invite</th>
                                                <th >Company Name</th>
                                                <th >Person Name</th>
                                                <th >Designation</th>
                                                <th >Email</th>
                                                <th >Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.ExhibitorList.length > 0 ? <>{
                                                    this.state.ExhibitorList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Exhibitor')}
                                                                />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {isVisitorList && <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to Visitor's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th >Invite</th>
                                                <th style={{ width: '500px' }}>Company Name</th>
                                                <th style={{ width: '530px' }}>Person Name</th>
                                                <th style={{ width: '500px' }}>Designation</th>
                                                <th style={{ width: '500px' }}>Email</th>
                                                <th style={{ width: '500px' }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.VisitorList.length > 0 ? <>{
                                                    this.state.VisitorList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Visitor')}
                                                                />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {isDelegateList && <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to Delegate's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th >Invite</th>
                                                <th style={{ width: '500px' }}>Company Name</th>
                                                <th style={{ width: '530px' }}>Person Name</th>
                                                <th style={{ width: '500px' }}>Designation</th>
                                                <th style={{ width: '500px' }}>Email</th>
                                                <th style={{ width: '500px' }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.DelegateList.length > 0 ? <>{
                                                    this.state.DelegateList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Delegate')} />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {isVIPList && <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to VIP's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th >Invite</th>
                                                <th style={{ width: '500px' }}>Company Name</th>
                                                <th style={{ width: '530px' }}>Person Name</th>
                                                <th style={{ width: '500px' }}>Designation</th>
                                                <th style={{ width: '500px' }}>Email</th>
                                                <th style={{ width: '500px' }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.VIPList.length > 0 ? <>{
                                                    this.state.VIPList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'VIP')} />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {isGuestList && <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to Guest's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th >Invite</th>
                                                <th style={{ width: '500px' }}>Company Name</th>
                                                <th style={{ width: '530px' }}>Person Name</th>
                                                <th style={{ width: '500px' }}>Designation</th>
                                                <th style={{ width: '500px' }}>Email</th>
                                                <th style={{ width: '500px' }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.GuestList.length > 0 ? <>{
                                                    this.state.GuestList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Guest')} />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {isSpeakerList && <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to Speaker's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th >Invite</th>
                                                <th style={{ width: '500px' }}>Company Name</th>
                                                <th style={{ width: '530px' }}>Person Name</th>
                                                <th style={{ width: '500px' }}>Designation</th>
                                                <th style={{ width: '500px' }}>Email</th>
                                                <th style={{ width: '500px' }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.SpeakerList.length > 0 ? <>{
                                                    this.state.SpeakerList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'speaker')} />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            {isGovtList && <div className="col-md-12 p-0 mt-3">
                                <div className="table-responsive">
                                    <p className="m-0"><strong>Invite to Goverment Officer's:</strong></p>
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th >Invite</th>
                                                <th style={{ width: '500px' }}>Company Name</th>
                                                <th style={{ width: '530px' }}>Person Name</th>
                                                <th style={{ width: '500px' }}>Designation</th>
                                                <th style={{ width: '500px' }}>Email</th>
                                                <th style={{ width: '500px' }}>Country</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.GovtList.length > 0 ? <>{
                                                    this.state.GovtList.map((data, i) => (
                                                        <tr key={Math.random()}>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <input type='checkbox'
                                                                    checked={data.isChecked}
                                                                    onChange={(e) => this.oCheckbox(e.target.checked, i, 'Govt')} />
                                                            </td>
                                                            <td >{data.CompanyName}</td>
                                                            <td >{data.Name}</td>
                                                            <td >{data.Designation}</td>
                                                            <td >{data.EmailID}</td>
                                                            <td >{data.CountryName}</td>
                                                        </tr>
                                                    ))}
                                                </> :
                                                    <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>}
                            <div className="row mt-3" style={{ margin: 'auto', width: '98%' }}>
                                <div class="col-md-12">
                                    {InvitationEventId != '' && <button type="button" class="btn btn-aqua rounded-0" style={{ float: 'right' }}
                                        onClick={() => this.insertUpdateInvitationAllocationt()}>
                                        Save
                                    </button>}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '10%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text text-danger">Do you really want to delete this record?</h5>

                                {/* <button Event="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button Event="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteDelegateInvitationAllocationt(this.state.deleteID)}
                                    >Yes</button>
                                    <button Event="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, insertUpdate_InvitationAllocation_action, getInvitationAllocation_action })(Delegate_InvitationAllocationtList));
